export default __webpack_public_path__ + "static/media/info-numeros-interno.d89bc82e.svg";